const locale = {
  LOADER_TEXT: 'Loading, please wait...',
};

export default locale;
